import React, { Component, } from 'react'

import {colors, strings} from './../../cc-imports'

// import './cc-input.css'
import './../../styles/css/components/CCInput/cc-input.css'

import PropTypes from 'prop-types';

class CCInput extends Component {

    static propTypes = {
        height : PropTypes.number,
        inputClassName : PropTypes.string,
        borderBottomWidth : PropTypes.number,
        borderBottomColor: PropTypes.string,
        placeholderTextColor : PropTypes.string,
        placeholder : PropTypes.string,
        selectionColor : PropTypes.string,
        textProps : PropTypes.object,
        required : PropTypes.bool,
        requiredErrorText : PropTypes.string,

        onEndEditing : PropTypes.func,
        returnKeyType : PropTypes.string,

        className : PropTypes.string,

        error : PropTypes.string,
        errorClassName: PropTypes.string,

        customValidate : PropTypes.func,

        label : PropTypes.string,
        labelColor : PropTypes.string,
        labelEndTop : PropTypes.number,
        labelClassName : PropTypes.string,

        type : PropTypes.string,
        immediate : PropTypes.bool,
        labelProps : PropTypes.object,
        value : PropTypes.string,

        editable : PropTypes.bool
    }

    static defaultProps = {
        height : 40,

        inputFontSize : 18,
        inputColor: colors.theme.input_text_color,
        borderBottomWidth : 2,
        borderBottomColor: colors.theme.input_underline_color2,
        placeholderTextColor : colors.theme.input_place_holder_color,
        placeholder : undefined,
        selectionColor : colors.theme.input_text_color,
        textProps : {},
        required: false,
        requiredErrorText :strings('required'),

        onEndEditing : ()=>{},
        returnKeyType : "next",

        errorClassName : '',

        customValidate : undefined,

        label : "Text Here",
        labelColor : colors.theme.input_text_color,
        labelEndTop : 0,
        labelClassName : '',

        type : 'text',
        immediate : false,
        labelProps : {},
        value : undefined,

        editable : true,
        className : '',
        inputClassName : ''
    }

    constructor(props) {
        super(props)
        this.state = {
            isFocused: false,
            value : null,
            error : null
        };
        this._validateAndSave=this._validateAndSave.bind(this);
        this._validate=this._validate.bind(this);
        this._validateEmail=this._validateEmail.bind(this);
        this._validateNum=this._validateNum.bind(this);
        this._isInt=this._isInt.bind(this);
        this._validateText=this._validateText.bind(this);
        this._onChangeText=this._onChangeText.bind(this);
        this._getKeyboardType=this._getKeyboardType.bind(this);
    }

    componentWillMount() {
        //this._animatedIsFocused = new Animated.Value(this.state.value === null ? 0 : 1);
    }

    handleFocus = () => this.setState({ isFocused: true });
    handleBlur = () => this.setState({ isFocused: false });

    componentDidUpdate() {
        /*Animated.timing(this._animatedIsFocused, {
            toValue: (this.state.isFocused || this.state.value !== null) ? 1 : 0,
            duration: 200,
        }).start();*/
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.value && nextProps.value!=this.props.value){
            this.setState({value : nextProps.value})
        }
    }

    componentDidMount() {
        if(this.props.value){
            this.setState({value : this.props.value})
        }
    }

    _validateEmail(required, email) {
        var emailErr = this._validateText(required,email);

        if(emailErr){
            return emailErr;
        }

        if(email){
            var atpos = email.indexOf("@");
            var dotpos = email.lastIndexOf(".");

            var emailErr = atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length;
            if(emailErr){
                return strings('enter_valid_email');
            }
        }
        return;
    }

    _validateText(required, value) {
        let isValid = required == true ? !(value == undefined || value == null ||   value.length == 0 ) : true;
        if(!isValid){
            return this.props.requiredErrorText;
        }
        return;
    }

    _isInt(value) {
         return !isNaN(value) && (function(x) { return (x | 0) === x; })(parseFloat(value));
    }

    _validateNum(required, value) {
        let numErr = this._validateText(required,value);

        if(numErr){
            return numErr;
        }

        if(value){
            if(!this._isInt(value)){
                return strings('valid_number');
            }
        }
        return;
    }


    _validate(required, value) {
        let error = null;
        switch (this.props.type){
            case "email":
                error = this._validateEmail(required,value);
                break;
            case 'number':
                error = this._validateNum(required, value);
                break;
            default:
                error = this._validateText(required, value);
        }

        if(error){
            return error;
        }

        if(this.props.customValidate){
            var customErr = this.props.customValidate(value);
            if(customErr){
                return customErr;
            }
        }

        return;
    }


    _validateAndSave(value) {
        let error = this._validate(this.props.required,value);
        if(!error){
            this.props.onEndEditing(this.state.value);
        }
        this.setState({error : error});
    }

    _onChangeText(event) {
        const value =event.target.value;

        //console.log(' =----  ', value)
        if(this.props.immediate==true){
            var error = this._validate(this.props.required,value);
            this.setState({
                value : value,
                error : error
            });
            this.props.onEndEditing(error==null ? value:null);
        }
        else {
            this.setState({
                value : value,
            })
        }
    }

    _getKeyboardType(){
        switch (this.props.type){
            case 'email':
                return 'email-address';
            case 'number':
                return 'numeric';
            case 'phone':
                return 'phone-pad';
            default:
                return 'default';
        }
    }

    render() {
        const { label,labelProps, type, editable, labelClassName,inputClassName, errorClassName, className, ...props } = this.props;

        let textProps = this.props.textProps;

        return (
            <div className={className}>
                <h3 className={'cc-input-label-class '+labelClassName}>{label}</h3>
                <input  type={type}
                        editable={editable}
                        className={'cc-input '+ inputClassName}
                        {...textProps}
                        blurOnSubmit
                        onSubmit={()=>{this._validateAndSave(this.state.value)}}
                        onBlur={()=>{this._validateAndSave(this.state.value)}}
                        onChange={(event)=>{this._onChangeText(event)}} value={this.state.value}
                        placeholder={this.state.value === null ? '': this.props.placeholder}
                        placeholderTextColor={this.props.placeholderTextColor}
                        returnKeyType={this.props.returnKeyType}
                        selectionColor={this.props.selectionColor}
                       ></input>
                {
                    this.state.error != null &&
                        <h3  className={'cc-error '+errorClassName}>{this.state.error}</h3>
                }
            </div>
        );
    }
}

export default CCInput


// WEBPACK FOOTER //
// ./src/app/components/CCInput/CCInput2.js